import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./DynamicQrCodes.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";

function DynamicQrCodes({ setPartOfVideo2, partOfVideo2, resetAnimation, timeoutId, currentLocale }) {
  let history = useHistory();
  const [clicked, setClicked] = useState(false)
  function toggleAnimation() {
    setClicked(prev => !prev)
    if(!clicked) {
      resetAnimation(partOfVideo2, 2, true);
      clearTimeout(timeoutId.current[2]);
    } else {
      resetAnimation(partOfVideo2, 2);
    }
  }

  function isMobile() {
    if (window.innerWidth <= 700) {
      return true;
    } else {
      return false;
    }
  }

  function handleQrClick(partOfVideo2) {
    if (!isMobile()) {
      return
    }
    if (partOfVideo2 === 0 || partOfVideo2 == null) {
      history.push(`/feedback`);
    } else if (partOfVideo2 === 1) {
      history.push(`/productpage`);
    } else if (partOfVideo2 === 2) {
      history.push(`/bizzcard`);
    } else if (partOfVideo2 === 3) {
      history.push(`/multientry`);
    }
  }

  useEffect(() => {
    window.addEventListener("resize", isMobile);
    return () => {
      window.removeEventListener("resize", isMobile);
    };
  }, []);
  return (
    <section id="what-can-dynamic-qr-codes-do">
      <h2>
        <FormattedMessage id="home.dynamic.h" />
      </h2>
      <p>
        <FormattedMessage id="home.dynamic.p" />
      </p>
      <div className="content">
      <LazyLoad offset={800} once className="images-wrapper">
        <div className={`left-wrapper ${clicked ? "shifted" : ""}`}>
          <div className={`person-wrapper`}>
            {/* <img className="person" src="images/person1.png" alt="" /> */}
            <img
              className={`person ${
                (partOfVideo2 === 0 || partOfVideo2 === null) && "active"
              }`}
              src="images/dynamic-qr/person1.png"
              alt=""
            />
            <img
              className={`person ${partOfVideo2 === 1 && "active"}`}
              src="images/dynamic-qr/person2.png"
              alt=""
            />
            <img
              className={`person ${partOfVideo2 === 2 && "active"}`}
              src="images/dynamic-qr/person3.png"
              alt=""
            />
            <img
              className={`person ${partOfVideo2 === 3 && "active"}`}
              src="images/dynamic-qr/person4.png"
              alt=""
            />
            <p className="name">
              {partOfVideo2 === 1 ? (
                <FormattedMessage id="home.dynamic.person2.name" />
              ) : partOfVideo2 === 2 ? (
                <FormattedMessage id="home.dynamic.person3.name" />
              ) : partOfVideo2 === 3 ? (
                <FormattedMessage id="home.dynamic.person4.name" />
              ) : (
                <FormattedMessage id="home.dynamic.person1.name" />
              )}
            </p>
            <p>
              {partOfVideo2 === 1 ? (
                <FormattedMessage id="home.dynamic.person2.job" />
              ) : partOfVideo2 === 2 ? (
                <FormattedMessage id="home.dynamic.person3.job" />
              ) : partOfVideo2 === 3 ? (
                <FormattedMessage id="home.dynamic.person4.job" />
              ) : (
                <FormattedMessage id="home.dynamic.person1.job" />
              )}
            </p>
          </div>
          <div onClick={() => handleQrClick(partOfVideo2)} className={`qr-wrapper`}>
            <img
              onClick={toggleAnimation}
              className={`qr ${
                (partOfVideo2 === 0 || partOfVideo2 === null) && "active"
              }`}
              src="images/dynamic-qr/dynamic1.png"
              alt=""
            />
            <img
              onClick={toggleAnimation}
              className={`qr ${partOfVideo2 === 1 && "active"}`}
              src="images/dynamic-qr/dynamic2.png"
              alt=""
            />
            <img
              onClick={toggleAnimation}
              className={`qr ${partOfVideo2 === 2 && "active"}`}
              src="images/dynamic-qr/dynamic3.png"
              alt=""
            />
            <img
              onClick={toggleAnimation}
              className={`qr ${partOfVideo2 === 3 && "active"}`}
              src="images/dynamic-qr/dynamic4.png"
              alt=""
            />
            <img className="arrow" src="images/long-arrow.svg" alt="" />
            <div className="text">
              <FormattedMessage id="home.dynamic.scan" />
            </div>
          </div>
        </div>
          <div className={`microweb-sample`}>
          <img
              className={`preview ${
                (partOfVideo2 === 0 || partOfVideo2 === null) && "active"
              } ${clicked ? "shifted" : ""}`}
              src={`images/dynamic-qr/preview1-${[currentLocale]}.png`}
              alt=""
            />
            <img
              className={`preview ${partOfVideo2 === 1 && "active"} ${clicked ? "shifted" : ""}`}
              src={`images/dynamic-qr/preview2-${[currentLocale]}.png`}
              alt=""
            />
            <img
              className={`preview ${partOfVideo2 === 2 && "active"} ${clicked ? "shifted" : ""}`}
              src={`images/dynamic-qr/preview3-${[currentLocale]}.png`}
              alt=""
            />
            <img
              className={`preview ${partOfVideo2 === 3 && "active"} ${clicked ? "shifted" : ""}`}
              src={`images/dynamic-qr/preview4-${[currentLocale]}.png`}
              alt=""
            />
          </div>
          {isMobile() ? <button className="green-button" onClick={()=> handleQrClick(partOfVideo2)}>Náhled mikrowebu</button> : <></>}

      </LazyLoad>
      <div className={`timeline-wrapper`}>
        <div className="texts-wrapper">
          <p
            className={`${partOfVideo2 === 0 && "active"}`}
            onClick={() => {
              resetAnimation(0, 2);
              setPartOfVideo2(0);
              setClicked(false)
            }}
          >
            <FormattedMessage id="home.dynamic.text1" />
          </p>
          <p
            className={`${partOfVideo2 === 1 && "active"}`}
            onClick={() => {
              resetAnimation(1, 2);
              setPartOfVideo2(1);
              setClicked(false)
            }}
          >
            <FormattedMessage id="home.dynamic.text2" />
          </p>
          <p
            className={`${partOfVideo2 === 2 && "active"}`}
            onClick={() => {
              resetAnimation(2, 2);
              setPartOfVideo2(2);
              setClicked(false)
            }}
          >
            <FormattedMessage id="home.dynamic.text3" />
          </p>
          <p
            className={`${partOfVideo2 === 3 && "active"}`}
            onClick={() => {
              resetAnimation(3, 2);
              setPartOfVideo2(3);
              setClicked(false)
            }}
          >
            <FormattedMessage id="home.dynamic.text4" />
          </p>
        </div>
        <div className="timeline timeline2">
          <div
            className={`bar ${
              partOfVideo2 === 0
                ? "part0"
                : partOfVideo2 === 1
                ? "part1"
                : partOfVideo2 === 2
                ? "part2"
                : partOfVideo2 === 3
                ? "part3"
                : ""
            }`}
          ></div>
          <div
            onClick={() => {
              resetAnimation(0, 2);
              setPartOfVideo2(0);
            }}
            className={`point ${partOfVideo2 >= 0 && "active"}`}
          ></div>
          <div
            onClick={() => {
              resetAnimation(1, 2);
              setPartOfVideo2(1);
            }}
            className={`point ${partOfVideo2 >= 1 && "active"}`}
          ></div>
          <div
            onClick={() => {
              resetAnimation(2, 2);
              setPartOfVideo2(2);
            }}
            className={`point ${partOfVideo2 >= 2 && "active"}`}
          ></div>
          <div
            onClick={() => {
              resetAnimation(3, 2);
              setPartOfVideo2(3);
            }}
            className={`point ${partOfVideo2 === 3 && "active"}`}
          ></div>
        </div>
      </div>
    </div>
    </section>
  );
}

export default DynamicQrCodes;
